import {
  Actor,
  CollisionType,
  Engine,
  SpriteSheet,
  vec,
  Vector,
} from "excalibur";
import { Resources } from "./resources";
import { Constants } from "./const";

const plants = [
  "apple",
  "banana",
  "orange",
  "pear",
  "strawberry",
  "avocado",
  "broccoli",
  "green-pepper",
  "red-pepper",
  "yellow-pepper",
  "blueberry",
  "watermelon",
  "carrot",
  "cauliflower",
  "leek",
  "cherry",
  "green-chili",
  "red-chili",
  "sweetcorn",
  "courgette",
  "aubergine",
  "green-grape",
  "red-grape",
  "kiwi",
  "peach",
  "lettuce",
  "pineapple",
  "peas",
  "turnip",
  "red-onion",
  "kidney-bean",
  "peanut",
  "coconut",
  "redcurrant",
  "raspberry",
  "blackberry",
] as const;

export function randomPlantType(): PlantType {
  const index = Math.floor(Math.random() * plants.length);
  return plants[index];
}

export type PlantType = (typeof plants)[number];

function getSpriteForPlantType(plantType: PlantType) {
  const sheet = SpriteSheet.fromImageSource({
    image: Resources.PlantSheet1,
    grid: {
      rows: 14,
      columns: 14,
      spriteWidth: 36,
      spriteHeight: 36,
    },
  });
  switch (plantType) {
    case "apple":
      return sheet.getSprite(1, 0);
    case "banana":
      return sheet.getSprite(10, 0);
    case "orange":
      return sheet.getSprite(3, 9);
    case "pear":
      return sheet.getSprite(9, 9);
    case "strawberry":
      return sheet.getSprite(13, 0);
    case "avocado":
      return sheet.getSprite(5, 0);
    case "green-pepper":
      return sheet.getSprite(12, 0);
    case "red-pepper":
      return sheet.getSprite(0, 1);
    case "yellow-pepper":
      return sheet.getSprite(1, 1);
    case "blueberry":
      return sheet.getSprite(2, 1);
    case "broccoli":
      return sheet.getSprite(7, 1);
    case "carrot":
      return sheet.getSprite(11, 2);
    case "leek":
      return sheet.getSprite(0, 3);
    case "cherry":
      return sheet.getSprite(3, 3);
    case "green-chili":
      return sheet.getSprite(8, 3);
    case "red-chili":
      return sheet.getSprite(9, 3);
    case "sweetcorn":
      return sheet.getSprite(3, 4);
    case "courgette":
      return sheet.getSprite(9, 4);
    case "aubergine":
      return sheet.getSprite(9, 5);
    case "green-grape":
      return sheet.getSprite(10, 6);
    case "red-grape":
      return sheet.getSprite(11, 6);
    case "kiwi":
      return sheet.getSprite(9, 7);
    case "lettuce":
      return sheet.getSprite(12, 7);
    case "peach":
      return sheet.getSprite(7, 9);
    case "watermelon":
      return sheet.getSprite(3, 13);
    case "peas":
      return sheet.getSprite(6, 9);
    case "turnip":
      return sheet.getSprite(13, 10);
    case "red-onion":
      return sheet.getSprite(1, 9);
    case "cauliflower":
      return sheet.getSprite(12, 2);
    case "pineapple":
      return sheet.getSprite(3, 10);
    case "kidney-bean":
      return sheet.getSprite(7, 11);
    case "peanut":
      return sheet.getSprite(8, 9);
    case "coconut":
      return sheet.getSprite(0, 4);
    case "redcurrant":
      return sheet.getSprite(7, 4);
    case "raspberry":
      return sheet.getSprite(11, 11);
    case "blackberry":
      return sheet.getSprite(10, 11);
  }
}

export class Plant extends Actor {
  Type: PlantType;

  constructor(
    t: PlantType,
    pos: Vector = vec(Constants.GameWidth, Constants.GameHeight - 100),
    moveLeft: boolean = true,
  ) {
    super({
      // Giving your actor a name is optional, but helps in debugging using the dev tools or debug mode
      // https://github.com/excaliburjs/excalibur-extension/
      // Chrome: https://chromewebstore.google.com/detail/excalibur-dev-tools/dinddaeielhddflijbbcmpefamfffekc
      // Firefox: https://addons.mozilla.org/en-US/firefox/addon/excalibur-dev-tools/
      name: t,
      pos: pos,
      width: 36,
      height: 36,
      vel: vec(moveLeft ? Constants.FoodSpeed : 0, 0),
      // anchor: vec(0, 0), // Actors default center colliders and graphics with anchor (0.5, 0.5)
      collisionType: CollisionType.Passive, // Collision Type Active means this participates in collisions read more https://excaliburjs.com/docs/collisiontypes
    });
    this.Type = t;
  }

  override onInitialize(engine: Engine): void {
    super.onInitialize(engine);
    this.graphics.add(getSpriteForPlantType(this.Type));
    this.on("exitviewport", () => this.kill());
  }
}
